var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpnepositn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#5E58DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9548 16.9241C18.549 16.3468 19.4987 16.3606 20.0759 16.9548L24.8589 21.8785L29.9544 16.9245C30.5484 16.347 31.498 16.3604 32.0755 16.9544C32.653 17.5484 32.6396 18.498 32.0456 19.0755L25.8742 25.0755C25.5889 25.3529 25.205 25.5055 24.8071 25.4998C24.4093 25.4942 24.0299 25.3306 23.7527 25.0452L17.9241 19.0452C17.3468 18.451 17.3606 17.5013 17.9548 16.9241Z",
    fill: "#2D2268"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1655 24.0558C38.687 24.6995 38.588 25.644 37.9443 26.1655L25.6014 36.1655C25.0386 36.6215 24.2303 36.6102 23.6805 36.1385L12.0234 26.1385C11.3946 25.5992 11.3221 24.6522 11.8615 24.0234C12.4009 23.3946 13.3479 23.3222 13.9767 23.8616L24.6846 33.0473L36.0558 23.8346C36.6994 23.3131 37.644 23.4121 38.1655 24.0558Z",
    fill: "#2D2268"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpnepositn);
export default __webpack_public_path__ + "static/media/opnepositn.244419bf.svg";
export { ForwardRef as ReactComponent };